import { React, useEffect, useState } from "react";
import AppWrapper from "../../AppWrapper";
import supabase from "../../../supabase-client";
import { useNavigate } from "react-router-dom";
import { Badge, Button, IndexTable, LegacyCard, Page } from "@shopify/polaris";

function CarModels() {
  const navigate = useNavigate();
  const [models, setModels] = useState([]);

  useEffect(() => {
    async function getModels() {
      const { data, error } = await supabase
        .from("car_models")
        .select(
          "id, name, car_brands(name), show_on_website, cars(count), show_as"
        )
        .order("show_as", { ascending: true });
      if (error) {
        console.error(error.message);
        return { success: false, error: error.message };
      }
      setModels(data);
    }
    getModels();
  }, []);

  const rowMarkup = models.map((model, index) => (
    <IndexTable.Row
      id={model.id}
      key={model.id}
      position={index}
      onClick={() => {
        navigate(`/cars/models/edit?id=${model.id}`);
      }}
    >
      <IndexTable.Cell>{model.name}</IndexTable.Cell>
      <IndexTable.Cell>{model.car_brands.name}</IndexTable.Cell>
      <IndexTable.Cell>{model.cars[0].count}</IndexTable.Cell>
      <IndexTable.Cell>
        {
          <Badge tone={model.show_on_website ? "success" : ""}>
            {model.show_on_website ? "Si" : "No"}
          </Badge>
        }
      </IndexTable.Cell>
    </IndexTable.Row>
  ));

  return (
    <AppWrapper>
      <Page
        title="Modelos"
        primaryAction={
          <Button
            variant="primary"
            onClick={() => {
              navigate("/cars/models/edit");
            }}
          >
            Crear Modelo
          </Button>
        }
      >
        <div style={{ marginBottom: "2rem" }}>
          <LegacyCard>
            <IndexTable
              resourceName={{ singular: "Modelo", plural: "Modelos" }}
              itemCount={models?.length ?? 0}
              selectable={false}
              headings={[
                { title: "Modelo" },
                { title: "Marca" },
                { title: "Autos" },
                { title: "Público" },
              ]}
            >
              {rowMarkup}
            </IndexTable>
          </LegacyCard>
        </div>
      </Page>
    </AppWrapper>
  );
}

export default CarModels;
